import * as actionTypes from "./actionTypes";
import { licenseServices } from "../services/license.bank.service";

export const resetLicense = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_LICENSE,
  });
};

export const getLicense = (licenseId) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.LOAD_LICENSE });
    const res = await licenseServices.getLicense(licenseId);
    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.GET_LICENSE,
        payload: res.data.returnObject,
      });

      //set isLicenseFound to true in case this was a license activation for the first time
      // dispatch({
      //   type: "SET_IS_LICENSE_FOUND",
      //   payload: true,
      // });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      dispatch({
        type: actionTypes.GET_LICENSE,
        payload: null,
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({
      type: actionTypes.GET_LICENSE,
      payload: null,
    });
  }
};

export const updateLicense =
  (licenseId, modules, success, error) => async (dispatch) => {
    try {
      dispatch({ type: actionTypes.SET_PROCESSING });
      const res = await licenseServices.updateLicense(licenseId, {
        moduleIds: modules,
      });
      dispatch({
        type: actionTypes.UPDATE_BANK_LICENSE,
      });
      if (res.data.responseCode === "SUCCESS") success(res.data.message);
      else if (res.data.responseCode === "VALIDATION_ERROR") {
        error(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

export const changeLicense =
  (licenseId, data, success, error) => async (dispatch, getState) => {
    try {
      dispatch({ type: actionTypes.SET_PROCESSING });
      const res = await licenseServices.changeLicense(licenseId, data);
      dispatch({
        type: actionTypes.CHANGE_BANK_LICENSE,
      });
      if (res.data.responseCode === "SUCCESS") {
        const { licenseValidity } = getState();

        success(res.data.message);

        if (licenseValidity.isLocked) {
          dispatch({
            type: "LOCK_LICENSE",
            payload: false,
          });
        }
      } else if (res.data.responseCode === "VALIDATION_ERROR") {
        error(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

export const customizeModules =
  (licenseId, data, success, error) => async (dispatch) => {
    try {
      dispatch({ type: actionTypes.SET_PROCESSING });
      const res = await licenseServices.customizeModules(licenseId, data);
      dispatch({
        type: actionTypes.CUSTOMIZE_MODULES,
        payload: res.data.returnObject,
      });

      if (res.data.responseCode === "SUCCESS") success(res.data.message);
      else if (res.data.responseCode === "VALIDATION_ERROR") {
        error(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

export const getLicenseHistory = (licenseId, error) => async (dispatch) => {
  try {
    dispatch({
      type: actionTypes.LOAD_LICENSE_HISTORY,
      payload: true,
    });

    const res = await licenseServices.getLicenseHistory(licenseId);

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.GET_LICENSE_HISTORY,
        payload: res.data.returnObject,
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      dispatch({
        type: actionTypes.LOAD_LICENSE_HISTORY,
        payload: false,
      });
      error(res.data.message);
    }
  } catch (e) {
    dispatch({
      type: actionTypes.LOAD_LICENSE_HISTORY,
      payload: false,
    });
    error(e.message);
  }
};

export const getModules = (error) => async (dispatch) => {
  try {
    const res = await licenseServices.getModules();

    if (res.data.responseCode === "SUCCESS") {
      dispatch({
        type: actionTypes.GET_MODULES,
        payload: res.data.returnObject,
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
  }
};
